// extracted by mini-css-extract-plugin
module.exports = {"mainblock":"BrandKit-styles-module--mainblock--1BZlL"};